import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getJobDisplayTitle, getJobSchedule } from '../openJobsData';

export default function OpenJobListRow({ job, selected }) {
	const rowRef = useRef(null);

	useEffect(() => {
		if (selected) {
			rowRef.current?.scrollIntoView({ block: 'nearest' });
		}
	}, [selected]);

	return (
		<Link
			innerRef={rowRef}
			className={`open-job-list-row${selected ? ' is-selected' : ''}`}
			to={`/jobs/${job.id}`}
			aria-current={selected ? 'page' : undefined}>
			<div className="open-job-list-row-copy">
				<span className="open-job-list-row-title">
					{getJobDisplayTitle(job)}
				</span>
				{getJobSchedule(job) ? (
					<span className="open-job-list-row-meta">{getJobSchedule(job)}</span>
				) : null}
			</div>
			<span className="open-job-list-row-chevron">
				<img src="/ats/icons/chevron-right-icon.svg" alt="" />
			</span>
		</Link>
	);
}
